"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _shortUrlsByRedirects = _interopRequireDefault(require("./shortUrlsByRedirects.graphql"));
var _shortUrlsByShortUrl = _interopRequireDefault(require("./shortUrlsByShortUrl.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var shortUrlsTable = function shortUrlsTable() {
  var byRedirects = {
    query: _shortUrlsByRedirects["default"],
    rowKey: 'eventId',
    handle: 'shortUrlsByRedirects',
    columns: [{
      name: 'eventAt',
      label: 'Redirect Date/Time',
      filter: true,
      sort: true,
      width: '170px',
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'targetId',
      label: "Short URL\xA0ID",
      className: 'text-center',
      width: '5%',
      sort: true,
      filter: true
    }, {
      name: 'pawnId',
      label: 'Viewer ID',
      className: 'text-center',
      width: '5%',
      sort: true,
      filter: true
    }, {
      name: 'eventId',
      label: 'Short Code',
      sort: true,
      filter: true,
      width: '10%',
      render: function render(_ref) {
        var value = _ref.value,
          row = _ref.row;
        if (!row['shortUrl.shortCode']) {
          return 'Deleted';
        }
        return /*#__PURE__*/_react["default"].createElement("span", null, row['shortUrl.shortCode']);
      }
    }, {
      name: 'eventType',
      label: 'Short URL',
      sort: true,
      filter: true,
      render: function render(_ref2) {
        var value = _ref2.value,
          row = _ref2.row;
        if (!row['shortUrl.sourceUrl']) {
          return 'Deleted';
        }
        var url = row['shortUrl.sourceUrl'].replace('https:', '');
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: url,
          rel: "noopener noreferrer",
          target: "_blank"
        }, row['shortUrl.sourceUrl']);
      }
    }, {
      name: 'url',
      label: 'Redirect URL',
      sort: true,
      filter: true,
      render: function render(_ref3) {
        var value = _ref3.value,
          row = _ref3.row;
        var url = row.url.replace('https:', '');
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: url,
          rel: "noopener noreferrer",
          target: "_blank"
        }, row.url);
      }
    }]
  };
  var byShortUrl = {
    query: _shortUrlsByShortUrl["default"],
    rowKey: 'shortUrlId',
    handle: 'shortUrlsByShortUrl',
    columns: [{
      name: 'shortUrlId',
      label: "Short URL\xA0ID",
      className: 'text-center',
      width: '5%',
      sort: true,
      filter: true
    }, {
      name: 'targetUrl',
      label: 'Short URL',
      sort: true,
      filter: true,
      render: function render(_ref4) {
        var value = _ref4.value,
          row = _ref4.row;
        var sourceUrl = row.sourceUrl.replace('https:', '');
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: sourceUrl,
          rel: "noopener noreferrer",
          target: "_blank"
        }, row.sourceUrl);
      }
    }, {
      name: 'sourceUrl',
      label: 'Redirect URL',
      sort: true,
      filter: true,
      render: function render(_ref5) {
        var value = _ref5.value,
          row = _ref5.row;
        var targetUrl = row.targetUrl.replace('https:', '');
        return /*#__PURE__*/_react["default"].createElement("a", {
          href: targetUrl,
          rel: "noopener noreferrer",
          target: "_blank"
        }, row.targetUrl);
      }
    }, {
      name: 'eventCount',
      label: "#\xA0Redirects",
      className: 'text-center',
      width: '5%',
      sort: true,
      filter: true
    }, {
      name: 'firstDate.eventAt',
      label: 'First redirect',
      width: '170px',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'lastDate.eventAt',
      label: 'Last redirect',
      width: '170px',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "shortUrls",
    saveState: true,
    views: [{
      handle: 'shortUrlsByRedirects',
      title: 'Short URLs Redirects - by Event',
      table: byRedirects
    }, {
      handle: 'resourceViewByViewer',
      title: 'Short URLs Redirects - by Short URL',
      table: byShortUrl
    }]
  }));
};
var _default = exports["default"] = {
  name: 'shortUrls',
  title: 'Short URLs Log',
  content: shortUrlsTable()
};